import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../contexts/LanguageContext';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import '../Checkout.css';

interface CheckoutNavigationProps {
  currentStep: number;
  totalSteps?: number;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

const CheckoutNavigation: React.FC<CheckoutNavigationProps> = ({
  currentStep,
  totalSteps = 3,
  isLoading,
  onPrevious,
  onNext,
}) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const PreviousIcon = isRTL ? ChevronRightIcon : ChevronLeftIcon;
  const NextIcon = isRTL ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <div className="checkout-navigation">
      {currentStep > 1 && (
        <button
          type="button"
          className="btn-secondary"
          onClick={onPrevious}
          disabled={isLoading}
        >
          <PreviousIcon className="btn-icon" />
          {t('checkout.previous')}
        </button>
      )}

      {currentStep < totalSteps && (
        <button
          type="button"
          className="btn-primary"
          onClick={onNext}
          disabled={isLoading}
        >
          {t('checkout.next')}
          <NextIcon className="btn-icon" />
        </button>
      )}
    </div>
  );
};

export default CheckoutNavigation;
